import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCommandState } from "@air/cmdk";
import { memo, useCallback, useMemo } from "react";
import { SearchCommandGroup } from "~/components/SearchCommand/SearchCommandGroup";
import { SearchCommandSuggestionListItem } from "~/components/SearchCommand/SearchCommandSuggestionListItem";
export const SearchCommandSuggestionList = /*#__PURE__*/ memo((param)=>{
    let { suggestions, onSelect } = param;
    const search = useCommandState((state)=>state.search);
    const onSelectSearch = useCallback(()=>{
        onSelect(search);
    }, [
        onSelect,
        search
    ]);
    /**
   * Check if the search is not in the suggestions list
   */ const shouldShowSearch = useMemo(()=>{
        return !!search && !(suggestions === null || suggestions === void 0 ? void 0 : suggestions.includes(search));
    }, [
        search,
        suggestions
    ]);
    if (!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.length) && !search) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(SearchCommandGroup, {
        heading: search ? undefined : "Search suggestions",
        children: [
            shouldShowSearch && /*#__PURE__*/ _jsx(SearchCommandSuggestionListItem, {
                suggestion: search,
                onSelect: onSelectSearch
            }),
            suggestions === null || suggestions === void 0 ? void 0 : suggestions.map((suggestion)=>/*#__PURE__*/ _jsx(SearchCommandSuggestionListItem, {
                    suggestion: suggestion,
                    onSelect: onSelect
                }, suggestion))
        ]
    });
});
SearchCommandSuggestionList.displayName = "SearchCommandSuggestionList";
